/**
 * Returns theme token object based on dark/light mode.
 */
export default function useTheme(dark) {
  return {
    bg:        dark ? '#080808' : '#ffffff',
    bg2:       dark ? '#0e0e0e' : '#f8f5ee',
    surface:   dark ? '#111111' : '#ffffff',
    surfaceB:  dark ? '#181818' : '#fdf7e8',
    border:    dark ? 'rgba(201,162,39,0.15)' : 'rgba(201,162,39,0.25)',
    borderHov: dark ? 'rgba(201,162,39,0.5)'  : 'rgba(201,162,39,0.6)',
    text:      dark ? '#f5f5f5' : '#12080a',
    textSub:   dark ? '#9a9a9a' : '#6b5230',
    textMuted: dark ? '#555555' : '#9a7a50',
    gold:      '#c9a227',
    goldLight: '#e8c040',
    goldDim:   dark ? 'rgba(201,162,39,0.12)' : 'rgba(201,162,39,0.10)',
  };
}
